import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/dog/meritve/drob/misicaHrbet";

export const fetchBackMuscleMeasurementPage = createAsyncThunk(
  "backMuscle/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const createBackMuscleMeasurement = createAsyncThunk(
  "backMuscle/create",
  async (backMuscleMeasurement, { rejectWithValue }) => {
    try {
      const response = await ApiClient.post(baseUrl, backMuscleMeasurement);

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const backMuscleMeasurementSlice = createSlice({
  name: "backMuscleMeasurement",
  initialState: {
    isLoading: false,
    error: null,
    page: null,
  },
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.error = null;
      state.page = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBackMuscleMeasurementPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(fetchBackMuscleMeasurementPage.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchBackMuscleMeasurementPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createBackMuscleMeasurement.fulfilled, (state, _) => {
        state.isLoading = false;
      })
      .addCase(createBackMuscleMeasurement.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createBackMuscleMeasurement.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { reset: resetBackMuscleMeasurement } =
  backMuscleMeasurementSlice.actions;

export default backMuscleMeasurementSlice.reducer;
